<template>
  <span>{{ getOrderLineNo }}</span>
</template>

<script>
export default {
  props: ["value"],
  computed: {
    getOrderLineNo() {
      const orderLineNo = Number.parseInt(this.value, 10);
      return orderLineNo ? orderLineNo / 100 : this.value;
    }
  }
};
</script>
